<template>
    <div class="tt_category">
        <div v-if="category && hasTickets" class="tt_category--top">
            <h3 class="title title--h3">{{ category.name }}</h3>
            <div v-if="category.stocks.quota" class="quota">
                <IconSvg :name="'ticket'" />
                <span>{{ category?.currentStock }}</span>
            </div>
        </div>
        <div class="tt_category--inner">
            <slot />
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconSvg from '@/components/atoms/ASvg.vue';
    import { TicketTypeCategory } from '@/interfaces/TicketTypeCategory';
    interface Props {
        category: TicketTypeCategory,
        hasTickets: boolean
    }
    const props = withDefaults(defineProps<Props>(), {})
</script>
